import React from 'react'
import { createAuthProviderConfig } from './Auth.utils'
import { useNavigate } from '../Router/router'
import { AuthKitProvider } from '@workos-inc/authkit-react'
import useConfig from '../useConfig'

export type AuthProviderProps = {
  children: React.ReactNode
}
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const navigate = useNavigate()
  const providerConfig = createAuthProviderConfig(navigate)
  const { AUTH_REDIRECT_URI } = useConfig()
  return (
    <AuthKitProvider {...providerConfig} redirectUri={AUTH_REDIRECT_URI}>
      {children}
    </AuthKitProvider>
  )
}
